function filterSortBarLayout() {
  function addWidthToPlaceHolder() {
    const placeHolder = document.querySelector('.collection__placeholder');
    const actionBar = document.querySelector('.facets-container');
    const actionBarWidth = actionBar.clientWidth;
    if (placeHolder) {
      placeHolder.style.width = `${actionBarWidth}px`;
    }
  }

  // on load
  addWidthToPlaceHolder();

  // on resize
  window.addEventListener('resize', () => {
    addWidthToPlaceHolder();
  });
}

export { filterSortBarLayout as default };
